/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: [],

    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: [],

    iosPackageStoreList: [],
    androidPackageStoreList: [],
    h5PackageStoreList: [],
    windowsPackageStoreList: [],

    planInfo: [],

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_PACKAGE_LIST ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(
            function (res) {
                data = res.data.result;
                if (args.platform === 'IOS') {
                    commit('_iosPackageList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5PackageList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsPackageList', data);
                }
                else {
                    commit('_androidPackageList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_SDK_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(
            function (res) {
                data = res.data.sdk_versions;
                if (args.platform === 'IOS') {
                    commit('_iosSdkVersion', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5SdkVersion', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsSdkVersion', data);
                }
                else {
                    commit('_androidSdkVersion', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_EDIT_PLAN ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/games/' + gameCode + '/plans/' + args.plan_id, {}).then(
            function (res) {
                data = res.data.plan;
                data['plan_id'] = parseInt(data['plan_id']);
                if (args.operate_type === 'copy') {
                    data['package_id'] = '';
                    data['sdk_version_id'] = '';
                    data['store_id'] = '';
                }
                else {
                    data['package_id'] = parseInt(data['package_id']);
                    data['sdk_version_id'] = parseInt(data['sdk_version_id']);
                    data['store_id'] = data['store_id'] + '';
                }

                commit('_planInfo', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_PACKAGE_STORE ({state, commit, dispatch, rootState}, args) {
        let data = [];
        rootState.$helper.request.get('/ajaxrela/getpackagenamestorelist', {package_id: args.package_id}).then(
            function (res) {
                data = res.data.result;
                if (args.platform === 'IOS') {
                    commit('_iosPackageStoreList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5PackageStoreList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsPackageStoreList', data);
                }
                else {
                    commit('_androidPackageStoreList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_ANDROID_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/new', args).then(
            function (res) {
                data = res.data.created;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '添加成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '编辑失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_ANDROID_COPY_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/new', args).then(
            function (res) {
                data = res.data.created;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '复制成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '复制失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_ANDROID_EDIT_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/' + args.plan_id, args).then(
            function (res) {
                data = res.data.edited;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '编辑成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist', {platform: data.platform.toUpperCase()});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '编辑失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/configlist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });

    },
    GAME_SYNC ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let dataRes = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getcoregames', {game_code: gameCode}).then(
            function (res) {
                data = res.data;
                if (data) {
                    dataRes['mdata_app_id'] = data['mdata_app_id'];
                    dataRes['facebook_app_id'] = data['facebook_app_id'];
                    dataRes['facebook_app_url'] = data['facebook_app_url'];
                }
                else {

                }
                args.callback(dataRes);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });

    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _iosPackageList (state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList (state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList (state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList (state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    },
    _iosSdkVersion (state, args) {
        state.iosSdkVersion = args;
        console.log('_iosSdkVersion=', state.iosSdkVersion);
    },
    _androidSdkVersion (state, args) {
        state.androidSdkVersion = args;
        console.log('_androidSdkVersion=', state.androidSdkVersion);
    },
    _h5SdkVersion (state, args) {
        state.h5SdkVersion = args;
        console.log('_h5SdkVersion=', state.h5SdkVersion);
    },
    _windowsSdkVersion (state, args) {
        state.windowsSdkVersion = args;
        console.log('_windowsSdkVersion=', state.windowsSdkVersion);
    },
    _iosPackageStoreList (state, args) {
        state.iosPackageStoreList = args;
        console.log('_iosPackageStoreList=', state.iosPackageStoreList);
    },
    _androidPackageStoreList (state, args) {
        state.androidPackageStoreList = args;
        console.log('_androidPackageStoreList=', state.androidPackageStoreList);
    },
    _h5PackageStoreList (state, args) {
        state.h5PackageStoreList = args;
        console.log('_h5PackageStoreList=', state.h5PackageStoreList);
    },
    _windowsPackageStoreList (state, args) {
        state.windowsPackageStoreList = args;
        console.log('_windowsPackageStoreList=', state.windowsPackageStoreList);
    },
    _planInfo (state, args) {
        state.planInfo = args;
        console.log('_planInfo=', state.planInfo);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/sdk/configEdit.js